module.exports = __webpack_public_path__ + "img/rate.d8284c44.svg";